import { IResolveFilterToRequestReturn } from "~/pages/Staff/lib/resolveFilterToRequest";
import { TFilterDealerGroup } from "~/shared/model/types";

export const toEmployeeEducationDealerReportFilter = (
  filter: Partial<IResolveFilterToRequestReturn>
): TFilterDealerGroup => {
  return {
    ids: filter.DealerIds ?? [],
    cities: filter.city ?? [],
    FOs: filter.FO ?? [],
    countries: filter.country ?? [],
    subjects: filter.subject ?? [],
  };
};
